import { useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  ArrowDown,
  ArrowRight,
  BowlFood,
  Check,
  Dog,
  Drop,
  FacebookLogo,
  ForkKnife,
  InstagramLogo,
  Package,
  ShoppingBag,
  Storefront,
  WhatsappLogo
} from "@phosphor-icons/react";
import "./petfood.css";
import { brand, waLink } from "./petfoodBrand";

const estados = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila",
  "Colima",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "México",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatán",
  "Zacatecas"
];

const logo19Hermanos = "/petfood/logo-19-hermanos.png";
const logoPetFoodPrimary = "/petfood/logo-petfood-primario.png";
const logoPetFoodSimple = "/petfood/logo-petfood-simple.png";
const logoPetFoodMenu = "/petfood/logo-petfood-menu.png";
const miBoobPack = "/petfood/mi-boob.png";
const kanKanPack = "/petfood/kan-kan.png";
const silverKanCachorroPack = "/petfood/silver-kan-cachorro.png";
const bodegon = "/petfood/bodegon.png";
const croquetas = "/petfood/croquetas.png";
const campaignDogRed = "/petfood/dog-red.jpg";
const tabbyCat = "/petfood/tabby-cat.jpg";
const dogJump = "/petfood/dog-jump.jpg";
const introDog = "/petfood/dog-hand.jpg";
const gingerCat = "/petfood/ginger-cat.jpg";
const dogBowls = "/petfood/dog-bowls.png";
const dogTreat = "/petfood/dog-treat.png";
const horseImage = "/petfood/horse.jpg";
const roosterImage = "/petfood/rooster.jpg";
const silverCatPack = "/petfood/silver-cat.png";
const silverKanAdultPack = "/petfood/silver-kan-adulto.png";
const silverKanPremiumPack = "/petfood/silver-kan-premium.png";
const photoLayerName = "EJEMPLO, reemplazar con sesión Tototlán 20 a 24 oct";
const catImage = "/petfood/cat-lying.jpg";
const factoryImage = "/petfood/factory.jpg";
function Button({ tone = "red", className = "", ...props }) {
  return <button className={`button button--${tone} ${className}`} {...props} />;
}
function LinkButton({
  href,
  tone = "red",
  children,
  className = ""
}) {
  return <a className={`button button--${tone} ${className}`} href={href}>
      {children}
    </a>;
}
function Field({
  label,
  id,
  error,
  success,
  ...props
}) {
  const descriptionId = error ? `${id}-error` : void 0;
  return <label
    className={`field-label${error ? " is-error" : ""}${success ? " is-success" : ""}`}
    htmlFor={id}
  >
      <span>{label}</span>
      <input
    id={id}
    aria-describedby={descriptionId}
    aria-invalid={error ? "true" : void 0}
    {...props}
  />
      {error && <small className="field-error" id={descriptionId}>
          {error}
        </small>}
    </label>;
}
function Formula({ items }) {
  return <dl className="formula">
      {items.map(([value, label]) => <div key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>)}
    </dl>;
}
function Bag({
  name,
  role,
  ratio,
  sizes,
  description,
  rank,
  image,
  nutri,
  badge = true
}) {
  return <article
    className="product"
    style={{ "--rank": rank }}
  >
      <div className="product-face">
        <div
    className={`bag${image ? " bag--photo" : ""}`}
    aria-label={`Costal de ${name}`}
  >
          {image ? <>
              {badge && <span className="pack-badge">Empaque nuevo</span>}
              <img src={image} alt={`Empaque de ${name}`} />
            </> : <>
              {badge && <span>Empaque nuevo</span>}
              <strong>{name}</strong>
              <em>{role}</em>
              <b>{ratio}</b>
              <small>{sizes}</small>
            </>}
        </div>
        {nutri && <Formula items={nutri} />}
      </div>
      <p>{description}</p>
    </article>;
}
const ratioMarks = ["16/6", "18/8", "22/10"];
function RatioCycle() {
  const [index, setIndex] = useState(0);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const id = window.setInterval(() => {
      setIndex((current) => (current + 1) % ratioMarks.length);
      setTick((current) => current + 1);
    }, 2800);
    return () => window.clearInterval(id);
  }, []);
  const current = ratioMarks[index].split("");
  const previous = ratioMarks[(index + ratioMarks.length - 1) % ratioMarks.length].split("");
  return <div className="ratio-reel" aria-hidden="true">
      {current.map((char, tile) => {
        const prior = previous[tile] ?? "";
        const rolling = tick > 0 && char !== prior;
        return <span className={char === "/" ? "reel reel--mark" : "reel"} key={tile}>
            {rolling ? <span className="reel-track" key={`${tick}-${tile}`}>
                <span>{prior}</span>
                <span>{char}</span>
              </span> : <span className="reel-still">{char}</span>}
          </span>;
      })}
    </div>;
}
function scrollToStart(event) {
  event.preventDefault();
  const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  window.scrollTo({ top: 0, behavior });
  if (window.location.hash !== "#inicio") {
    window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}#inicio`);
  }
}
function HeroMedia({ relaunch }) {
  const videoRef = useRef(null);
  const useVideo = new URLSearchParams(window.location.search).get("media") === "video";
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          void video.play();
        } else {
          video.pause();
        }
      },
      { threshold: 0.25 }
    );
    observer.observe(video);
    return () => observer.disconnect();
  }, [useVideo]);
  return <figure className="hero-photo">
      <div className="hero-duo">
        <div className="hero-media hero-media--cat">
          {useVideo ? <video
    ref={videoRef}
    muted
    playsInline
    autoPlay
    poster={gingerCat}
    aria-label="Gato naranja de pie, con una pata alzada"
  >
              <source src="/img/hero.webm" type="video/webm" />
              <source src="/img/hero.mp4" type="video/mp4" />
            </video> : <img
    src={gingerCat}
    alt="Gato naranja de pie, con una pata alzada"
  />}
        </div>
        <div className="hero-media hero-media--dog">
          <img src={dogJump} alt="Perro café saltando" />
        </div>
      </div>
      {relaunch && <div className="hero-launch-bag" aria-label="Empaque nuevo">
          <span>Empaque nuevo</span>
          <strong>Pet Food</strong>
        </div>}
    </figure>;
}
function App() {
  const [species, setSpecies] = useState("dog");
  const [weight, setWeight] = useState(18);
  const [bagSize, setBagSize] = useState(20);
  const [price, setPrice] = useState("");
  const [zipStatus, setZipStatus] = useState("");
  const [zipError, setZipError] = useState("");
  const [quoteStatus, setQuoteStatus] = useState("");
  const [quoteErrors, setQuoteErrors] = useState({});
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [pastIntro, setPastIntro] = useState(false);
  const relaunch = new URLSearchParams(window.location.search).get("variante") === "relanzamiento";
  const calculator = useMemo(() => {
    const parsedPrice = price.trim() === "" ? null : Number(price);
    const hasPriceError = parsedPrice !== null && (!Number.isFinite(parsedPrice) || parsedPrice < 0);
    const hasWeightError = !Number.isFinite(weight) || weight <= 0;
    const grams = Math.round(weight * 12);
    const days = Math.max(1, Math.round(bagSize * 1e3 / grams));
    const cost = parsedPrice !== null && !hasPriceError ? parsedPrice / days : null;
    return {
      grams,
      days,
      cost,
      error: hasWeightError ? "El peso debe ser mayor a 0 kg." : hasPriceError ? "Escribe un precio v\xE1lido igual o mayor a $0." : ""
    };
  }, [weight, bagSize, price]);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const nodes = document.querySelectorAll(
      ".rise, .red-band h2, .red-lead, .discoveries > div, .portfolio .section-heading, .lineup, .stair-note, .staircase .product, .cat-feature, .nutrition .ratio, .ratio-explainer > div, .transition, .habits"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          entry.target.classList.remove("is-waiting");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -6% 0px" }
    );
    nodes.forEach((node) => {
      const index = [...node.parentElement.children].indexOf(node);
      node.style.setProperty("--rise-index", String(Math.max(index, 0)));
      const top = node.getBoundingClientRect().top;
      if (top < window.innerHeight * 0.9) {
        node.classList.add("is-in");
      } else {
        node.classList.add("is-waiting");
        observer.observe(node);
      }
    });
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const updateIntroState = () => {
      setPastIntro(window.scrollY > window.innerHeight * 0.86);
    };
    updateIntroState();
    window.addEventListener("scroll", updateIntroState, { passive: true });
    window.addEventListener("resize", updateIntroState);
    return () => {
      window.removeEventListener("scroll", updateIntroState);
      window.removeEventListener("resize", updateIntroState);
    };
  }, []);
  function submitZip(event) {
    event.preventDefault();
    const zip = String(
      new FormData(event.currentTarget).get("zip") ?? ""
    ).trim();
    if (!/^\d{5}$/.test(zip)) {
      setZipError("Escribe un c\xF3digo postal de 5 d\xEDgitos.");
      setZipStatus("");
      return;
    }
    setZipError("");
    setZipStatus(
      "Te confirmamos existencias, precio final y env\xEDo por WhatsApp."
    );
  }
  function submitQuote(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);
    const value = (name) => String(data.get(name) ?? "").trim();
    const errors = {};
    if (value("name").length < 2)
      errors.name = "Escribe tu nombre o el de tu negocio.";
    if (value("phone").replace(/\D/g, "").length < 10) {
      errors.phone = "Escribe un tel\xE9fono de 10 d\xEDgitos.";
    }
    if (!/^\d{5}$/.test(value("businessZip"))) {
      errors.businessZip = "Escribe un c\xF3digo postal de 5 d\xEDgitos.";
    }
    if (!value("state")) errors.state = "Selecciona tu estado.";
    if (value("city").length < 2) errors.city = "Escribe la ciudad o poblaci\xF3n.";
    if (!value("businessType"))
      errors.businessType = "Selecciona el tipo de negocio.";
    if (value("products").length < 5) {
      errors.products = "Indica al menos un producto y el volumen aproximado.";
    }
    setQuoteErrors(errors);
    setQuoteStatus("");
    if (Object.keys(errors).length > 0) return;
    setQuoteLoading(true);
    window.setTimeout(() => {
      setQuoteLoading(false);
      setQuoteStatus("Recibimos tus datos. Te respondemos por WhatsApp.");
      form.reset();
    }, 600);
  }
  function clearQuoteError(field) {
    setQuoteErrors((current) => ({ ...current, [field]: "" }));
  }
  return <div className="site-shell">
      <header className={`nav ${pastIntro ? "nav--visible" : "nav--hidden"}`}>
        <a
    className="logo-slot logo-slot--primary"
    href="#inicio"
    aria-label="División Pet Food, ir al inicio"
    onClick={scrollToStart}
  >
          <img src={logoPetFoodMenu} alt="División Pet Food, Los 19 Hermanos" />
        </a>
        <nav aria-label="Navegación principal">
          <a href="#productos">Productos</a>
          <a href="#nutricion">Nutrición</a>
          <a href="#proceso">Proceso</a>
          <a href="#comprar">Dónde comprar</a>
          <a href="#distribuye">Distribuye</a>
        </nav>
        <div className="nav-tools">
          <a
    className="nav-social"
    href={brand.instagram.url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram de 19H Pet Food"
  >
            <InstagramLogo weight="regular" aria-hidden="true" />
          </a>
          <a
    className="nav-social"
    href={brand.facebook.url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook de 19H Pet Food"
  >
            <FacebookLogo weight="regular" aria-hidden="true" />
          </a>
          <LinkButton href={waLink("Hola, quiero información de Pet Food.")} className="nav-cta">
            <WhatsappLogo weight="regular" aria-hidden="true" />
            <span>Escríbenos por WhatsApp</span>
          </LinkButton>
        </div>
      </header>

      <main>
        <section
    className="intro-cover"
    id="inicio"
    aria-label="Pet Food de 19 Hermanos"
  >
          <div className="intro-grid" aria-hidden="true">
            <figure>
              <img src={campaignDogRed} alt="" />
            </figure>
            <figure>
              <img src={tabbyCat} alt="" />
            </figure>
            <figure>
              <img src={introDog} alt="" />
            </figure>
          </div>
          <div className="intro-shade" aria-hidden="true" />
          <div className="intro-logo">
            <img src={logoPetFoodSimple} alt="Pet Food de 19 Hermanos" />
          </div>
          <div className="intro-purpose">
            <p>
              Alimento para perro y gato, directo de nuestra planta en Tototlán.
            </p>
            <LinkButton href="#descubre">Encuentra su alimento</LinkButton>
          </div>
        </section>

        <div className="content-panel">
          <section
    className={`hero wrap${relaunch ? " hero--relaunch" : ""}`}
    id="descubre"
  >
            <div className="hero-copy">
              <h1>
                {["Descubrimos", "que", "todo", "pod\xEDa", "ser"].map(
    (word, index) => <span
      className="hero-word"
      style={{ "--word-index": index }}
      key={word}
    >
                      {word}
                    </span>
  )}
                <span className="hero-last">
                  <span
    className="hero-word hero-word--red"
    style={{ "--word-index": 5 }}
  >
                    más fácil
                  </span>
                  .
                </span>
              </h1>
              <p>Empezando por elegir las croquetas de tu perro o tu gato.</p>
              <div className="hero-actions">
                <LinkButton href="#productos">
                  Encuentra su alimento{" "}
                  <ArrowDown weight="bold" aria-hidden="true" />
                </LinkButton>
                <LinkButton href="#comprar" tone="light">
                  Dónde comprar
                </LinkButton>
              </div>
              <a className="hero-distribute" href="#distribuye">
                ¿Tienes tienda o forrajera? Conoce cómo distribuir 19H
                <ArrowRight aria-hidden="true" />
              </a>
            </div>
            <HeroMedia relaunch={relaunch} />
          </section>

          <div className="trust-bar rise">
            <div className="wrap trust-bar-inner">
              <ul>
                <li>Alimento para perro y gato</li>
                <li>Nutrición hecha en Tototlán, Jalisco</li>
                <li>Envíos a todo México</li>
              </ul>
              <p className="trust-endorsement">
                <img src={logo19Hermanos} alt="" />
                <span>Con el respaldo de 19 Hermanos</span>
              </p>
            </div>
          </div>

          <section className="red-band" aria-labelledby="simple-title">
            <div className="wrap">
              <h2 id="simple-title">Lo simple también se construye.</h2>
              <p className="red-lead">
                Nos tomamos el camino largo para que tú tengas respuestas cortas.
              </p>
              <div className="discoveries">
                <div>
                  <span>Nutrición accesible</span>
                  <p>
                    Una buena croqueta también puede cuadrar con la quincena.
                    Puedes dar más sin gastar de más.
                  </p>
                </div>
                <div>
                  <span>Proceso inteligente</span>
                  <p>
                    Nuestra planta en Tototlán aprovecha la gravedad para mover
                    el alimento y mejorar sus propiedades.
                  </p>
                </div>
                <div>
                  <span>Elección clara</span>
                  <p>
                    Te decimos de frente para quién es, qué aporta y cuánto
                    rinde. Sin letra chiquita que descifrar.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="portfolio wrap" id="productos">
            <div className="section-heading">
              <div>
                <h2>
                  Una familia de nutrición que crece con ellos, descubre nuestra
                  nueva imagen
                </h2>
                <p>
                  Cada fórmula tiene un papel. Elige por especie y etapa, y
                  sabrás cuál le toca hoy y cuál después.
                </p>
              </div>
            </div>
            <figure className="lineup">
              <img
                src={bodegon}
                alt="Familia de costales Pet Food: Silver Kan, Mi Boob, Premium, Silver Cat, Cachorro y Kan Kan"
              />
            </figure>
            <div className="species-switch">
              <div className="segmented" aria-label="Selecciona especie">
                <Button
    tone="light"
    className={species === "dog" ? "active" : ""}
    aria-pressed={species === "dog"}
    onClick={() => setSpecies("dog")}
  >
                  <Dog aria-hidden="true" /> Perro
                </Button>
                <Button
    tone="light"
    className={species === "cat" ? "active" : ""}
    aria-pressed={species === "cat"}
    onClick={() => setSpecies("cat")}
  >
                  Gato
                </Button>
                <Button
    tone="light"
    className={species === "livestock" ? "active" : ""}
    aria-pressed={species === "livestock"}
    onClick={() => setSpecies("livestock")}
  >
                  Línea Pecuaria
                </Button>
              </div>
            </div>

            {species === "dog" && <>
                <p className="stair-note">
                  Elige por su edad, tamaño y actividad. El número más alto no
                  siempre es el que necesita.
                </p>
                <div
    className="staircase"
    aria-label="Alimentos para perro por aporte"
  >
                  <Bag
    name="Mi Boob"
    role="Rendimiento confiable"
    ratio="16/6"
    sizes="20 kg"
    description="Para alimentar bien todos los días cuidando el gasto."
    rank={1}
    image={miBoobPack}
    nutri={[["16%", "Proteína"], ["6%", "Grasa"], ["50%", "E.L.N."]]}
  />
                  <Bag
    name="Kan Kan"
    role="Nutrición cotidiana"
    ratio="16/6"
    sizes="20 y 25 kg"
    description="Multirraza, para la rutina de todos los días."
    rank={2}
    image={kanKanPack}
    nutri={[["16%", "Proteína"], ["6%", "Grasa"], ["48%", "E.L.N."]]}
  />
                  <Bag
    name="Silver Kan Adulto"
    role="El centro confiable"
    ratio="18/8"
    sizes="5 y 25 kg"
    description="Mantenimiento para la etapa adulta."
    rank={3}
    badge={false}
    image={silverKanAdultPack}
    nutri={[["18%", "Proteína"], ["8%", "Grasa"], ["48%", "E.L.N."]]}
  />
                  <Bag
    name="Silver Kan Premium"
    role="Mayor aporte"
    ratio="22/10"
    sizes="20 y 25 kg"
    description="Más proteína y grasa para perros activos."
    rank={4}
    image={silverKanPremiumPack}
    nutri={[["22%", "Proteína"], ["10%", "Grasa"], ["38%", "E.L.N."]]}
  />
                  <Bag
    name="Silver Kan Cachorro"
    role="Crecimiento y lactancia"
    ratio="26/10"
    sizes="5 y 20 kg"
    description="Para cachorros y hembras en lactancia."
    rank={5}
    image={silverKanCachorroPack}
    nutri={[["26%", "Proteína"], ["10%", "Grasa"], ["40%", "E.L.N."]]}
  />
                </div>
              </>}
            {species === "cat" && <div className="cat-feature">
                <figure
    className="campaign-photo cat-photo"
    data-layer-name={photoLayerName}
    title={photoLayerName}
  >
                  <img
    src={catImage}
    alt="Gato atigrado recostado"
  />
                </figure>
                <div className="bag bag--photo">
                  <span className="pack-badge">Empaque nuevo</span>
                  <img src={silverCatPack} alt="Empaque de Silver Cat" />
                </div>
                <div>
                  <h3>Silver Cat</h3>
                  <p>
                    Un gato no es un perro chico. Su fórmula se compara aparte.
                  </p>
                  <Formula items={[["30%", "Proteína"], ["10%", "Grasa"], ["38%", "E.L.N."]]} />
                </div>
              </div>}
            {species === "livestock" && <div className="pecuaria">
                <article className="pecuaria-card">
                  <figure>
                    <img src={roosterImage} alt="Gallo de combate de pie" />
                  </figure>
                  <div>
                    <p className="pecuaria-kicker">Aves de combate</p>
                    <h3>Gallo Mantenimiento 14%</h3>
                    <p>
                      Diseñado para maximizar la resistencia muscular, acelerar
                      el emplume y mantener la agilidad del ave en etapa de
                      cuida y desarrollo. Formulación de precisión técnica e
                      ingredientes de alta digestibilidad.
                    </p>
                    <Formula items={[["14%", "Proteína"], ["5%", "Grasa"], ["59%", "E.L.N."]]} />
                    <p className="pecuaria-sizes">Saco 40 kg y saco 10 kg</p>
                  </div>
                </article>
                <article className="pecuaria-card">
                  <figure>
                    <img src={horseImage} alt="Caballo al galope en una arena" />
                  </figure>
                  <div>
                    <p className="pecuaria-kicker">Equinos · Trabajo y exhibición</p>
                    <h3>Caballo Imperial</h3>
                    <p>
                      Alimento para equinos de trabajo y exhibición: maíz
                      rolado, avena, pellet de alfalfa, croqueta para caballo,
                      pastas de oleaginosas, melaza de caña, vitaminas y
                      minerales. Administrar de 3 a 6 kg según la condición del
                      animal.
                    </p>
                    <Formula items={[["16%", "Proteína"], ["8%", "Fibra"], ["48%", "E.L.N."]]} />
                    <p className="pecuaria-sizes">Saco 40 kg</p>
                  </div>
                </article>
              </div>}
          </section>

          <section className="nutrition wrap" id="nutricion">
            <div className="ratio">
              <RatioCycle />
              <h2>No son códigos secretos.</h2>
              <p>Parecen la contraseña del WiFi, pero te dicen algo más útil.</p>
              <img
                className="kibble"
                src={croquetas}
                alt="Plato de croquetas de Pet Food"
              />
            </div>
            <div className="ratio-explainer">
              <div>
                <strong>Qué significan</strong>
                <p>
                  El primer número es proteína; el segundo, grasa. 18/8 quiere
                  decir que cada 100 g de croqueta traen al menos 18 g de
                  proteína y 8 g de grasa.
                </p>
              </div>
              <div>
                <strong>Mínimos y máximos</strong>
                <p>
                  Proteína y grasa son mínimos: lo menos que trae. Fibra y
                  humedad son máximos: lo más que puede traer.
                </p>
              </div>
              <div>
                <strong>El número más alto no siempre gana</strong>
                <p>
                  La fórmula adecuada depende de su edad, tamaño y actividad. Si
                  tienes duda, pregúntale a su veterinario.
                </p>
              </div>
            </div>
            <div className="transition">
              <div className="transition-title">
                <h3>Cambia de alimento en 7 días</h3>
                <p>Mezcla ambas fórmulas para cuidar su digestión.</p>
              </div>
              {[
    ["D\xEDas 1 y 2", "25% nuevo"],
    ["D\xEDas 3 y 4", "50%"],
    ["D\xEDas 5 y 6", "75%"],
    ["D\xEDa 7", "100% nuevo"]
  ].map(([days, description], index) => <div className="timeline-step" key={days}>
                  <span>{index + 1}</span>
                  <strong>{days}</strong>
                  <small>{description}</small>
                </div>)}
            </div>
            <div className="habits">
              <span>
                <Drop aria-hidden="true" /> Agua fresca todo el día
              </span>
              <span>
                <ForkKnife aria-hidden="true" /> Dos comidas al día
              </span>
              <span>
                <BowlFood aria-hidden="true" /> Comedero limpio
              </span>
              <span>
                <Package aria-hidden="true" /> Costal cerrado, en lugar fresco y
                seco
              </span>
            </div>
          </section>

          <section className="calculator-wrap wrap rise" id="calculadora">
            <div className="calculator-intro">
              <span className="eyebrow">Haz cuentas</span>
              <h2>¿Cuánto te dura el Costal?</h2>
              <p>Compara por rendimiento, no solo por el precio del costal.</p>
            </div>
            <div className="calculator-controls">
              <label className="range-label" htmlFor="weight">
                <span>Peso de tu perro (kg)</span>
                <strong>{weight} kg</strong>
              </label>
              <input
    id="weight"
    type="range"
    min="2"
    max="60"
    value={weight}
    onChange={(event) => setWeight(Number(event.target.value))}
  />
              <fieldset>
                <legend>Tamaño del bulto</legend>
                <div className="segmented bag-selector">
                  {[20, 25].map((size) => <Button
    tone="light"
    type="button"
    className={bagSize === size ? "active" : ""}
    aria-pressed={bagSize === size}
    onClick={() => setBagSize(size)}
    key={size}
  >
                      {size} kg
                    </Button>)}
                </div>
              </fieldset>
              <Field
    label="Lo que pagas por el bulto (opcional)"
    id="price"
    type="number"
    min="0"
    inputMode="decimal"
    placeholder="$ 0.00"
    value={price}
    onChange={(event) => setPrice(event.target.value)}
    error={calculator.error.includes("precio") ? calculator.error : void 0}
  />
            </div>
            <div
    className={`calculator-result${calculator.error ? " is-error" : ""}`}
    aria-live="polite"
  >
              {calculator.error ? <>
                  <strong>Revisa los datos</strong>
                  <p>{calculator.error}</p>
                </> : <>
                  <span>Un bulto de {bagSize} kg te dura</span>
                  <strong>{calculator.days}</strong>
                  <b>días</b>
                  <div>
                    <p>
                      <strong>
                        Unas {(calculator.days / 7).toFixed(1)} semanas
                      </strong>
                    </p>
                    <p>
                      <strong>{calculator.grams} g al día</strong>
                      <span>Ración de referencia</span>
                    </p>
                    <p>
                      <strong>
                        {calculator.cost !== null ? `$${calculator.cost.toFixed(2)}` : "$\u2014"}
                      </strong>
                      <span>Costo por día</span>
                    </p>
                  </div>
                  <LinkButton href={waLink("Hola, quiero pedir un costal.")}>
                    Pide tu costal por WhatsApp
                  </LinkButton>
                </>}
            </div>
            <p className="calculator-note">
              Referencia para perro adulto en condición normal. Ajusta según
              edad, actividad y clima, y revisa la tabla de tu fórmula en el
              empaque.
            </p>
          </section>

          <section className="process wrap rise" id="proceso">
            <div className="process-heading">
              <h2>Nutrición también significa ciencia e ingeniería.</h2>
              <div className="process-belong">
                <p>
                  Detrás de cada croqueta hay decisiones de formulación, proceso,
                  calidad e inocuidad. Las tomamos en nuestra planta de Tototlán,
                  con el respaldo de Los 19 Hermanos.
                </p>
                <img src={logo19Hermanos} alt="Los 19 Hermanos" />
              </div>
            </div>
            <div className="process-story">
              <figure
    className="process-photo"
    data-layer-name={photoLayerName}
    title={photoLayerName}
  >
                <img
    src={factoryImage}
    alt="Interior metálico de una planta de producción"
  />
              </figure>
              <p>
                Trabajamos en una{" "}
                <strong>planta propia en Tototlán, Jalisco</strong>. Nuestro
                proceso aprovecha la gravedad para usar mejor la energía y
                comprobamos la aceptación y el aroma de cada fórmula antes de
                lanzarla.
              </p>
            </div>
          </section>

          <section className="buy wrap rise" id="comprar">
            <div className="buy-search">
              <h2>Encuéntralo cerca de ti.</h2>
              <p>
                Escribe tu código postal y te decimos dónde comprarlo, o armamos
                tu pedido por WhatsApp.
              </p>
              <figure
    className="campaign-photo buy-photo"
    data-layer-name={photoLayerName}
    title={photoLayerName}
  >
                <img
    src={dogBowls}
    alt="Perro negro frente a dos platos de croquetas"
  />
              </figure>
            </div>
            <div className="buy-side">
              <div className="buy-rows">
                {[
    [
      Storefront,
      "Tienda de mascotas, forrajera o veterinaria.",
      "Para reponer r\xE1pido, cerca de casa."
    ],
    [
      ShoppingBag,
      "Autoservicio.",
      "[Cadenas donde est\xE1 disponible]"
    ],
    [
      Package,
      "Pedido directo.",
      "Te confirmamos existencias, precio final y env\xEDo por WhatsApp."
    ]
  ].map(([Icon, title, text]) => {
    const RowIcon = Icon;
    return <a href="https://wa.me/" key={String(title)}>
                    <RowIcon aria-hidden="true" />
                    <span>
                      <strong>{String(title)}</strong>
                      <small>{String(text)}</small>
                    </span>
                    <ArrowRight aria-hidden="true" />
                  </a>;
  })}
              </div>
              <form className="buy-zip" onSubmit={submitZip} noValidate>
                <Field
    label="Tu código postal"
    id="zip"
    inputMode="numeric"
    pattern="[0-9]{5}"
    required
    placeholder="Ej. 44100"
    name="zip"
    error={zipError}
    success={Boolean(zipStatus)}
    onChange={() => {
      setZipError("");
      setZipStatus("");
    }}
  />
                <Button type="submit">
                  Escríbenos por WhatsApp <ArrowRight aria-hidden="true" />
                </Button>
              </form>
              {zipStatus && <p className="form-status is-success" role="status">
                  {zipStatus}
                </p>}
            </div>
          </section>

          <section className="distributors wrap rise" id="distribuye">
            <div className="distributor-copy">
              <span className="eyebrow">Para tu negocio</span>
              <h2>Primero prueba si se mueve. Después amplía tu pedido.</h2>
              <p>
                Para forrajeras, veterinarias, tiendas de mascotas, abarrotes y
                venta a granel en todo México.
              </p>
              <figure
    className="campaign-photo distributor-photo"
    data-layer-name={photoLayerName}
    title={photoLayerName}
  >
                <img
    src={dogTreat}
    alt="Perro saboreando una croqueta"
  />
              </figure>
              <div className="benefits">
                <span>
                  <Check aria-hidden="true" />
                  <p>
                    <b>Precio directo de fábrica.</b> Descuentos por volumen,
                    directo desde Tototlán. Pedido mínimo: (dato de 19H).
                  </p>
                </span>
                <span>
                  <Check aria-hidden="true" />
                  <p>
                    <b>Entrega coordinada.</b> Envíos consolidados a todo México,
                    directo a tu tienda o bodega.
                  </p>
                </span>
                <span>
                  <Check aria-hidden="true" />
                  <p>
                    <b>Te ayudamos a vender.</b> Material POP, mantas, catálogo
                    digital y asesoría para tu equipo.
                  </p>
                </span>
                <span>
                  <Check aria-hidden="true" />
                  <p>
                    <b>Argumentos para mostrador.</b> Tu cliente pregunta qué le
                    conviene. Cada fórmula tiene un papel claro y se explica en
                    menos de un minuto.
                  </p>
                </span>
              </div>
              <p className="pecuaria-note">
                ¿También vendes alimento pecuario?{" "}
                <a href={waLink("Hola, me interesa la línea pecuaria para mi negocio.")}>
                  Pregúntanos
                </a>{" "}
                por nuestra línea pecuaria.
              </p>
              <h3>Tu primer pedido en 4 pasos</h3>
              <ol>
                <li>
                  <span>1</span>
                  <p>Escríbenos por teléfono o WhatsApp.</p>
                </li>
                <li>
                  <span>2</span>
                  <p>Elige productos y presentaciones para tu zona.</p>
                </li>
                <li>
                  <span>3</span>
                  <p>Recibe tu cotización con descuentos por volumen.</p>
                </li>
                <li>
                  <span>4</span>
                  <p>Coordinamos la entrega en tu tienda o bodega.</p>
                </li>
              </ol>
            </div>
            <form
    className={`quote-form${quoteStatus ? " is-success" : ""}`}
    onSubmit={submitQuote}
    noValidate
  >
              <Field
    label="Nombre o negocio"
    id="name"
    name="name"
    required
    error={quoteErrors.name}
    onChange={() => clearQuoteError("name")}
  />
              <Field
    label="Teléfono"
    id="phone"
    name="phone"
    type="tel"
    required
    error={quoteErrors.phone}
    onChange={() => clearQuoteError("phone")}
  />
              <Field
    label="Código postal"
    id="businessZip"
    name="businessZip"
    inputMode="numeric"
    required
    error={quoteErrors.businessZip}
    onChange={() => clearQuoteError("businessZip")}
  />
              <label
    className={`field-label${quoteErrors.state ? " is-error" : ""}`}
    htmlFor="state"
  >
                <span>Estado</span>
                <select
    id="state"
    name="state"
    required
    defaultValue=""
    aria-invalid={quoteErrors.state ? "true" : void 0}
    aria-describedby={quoteErrors.state ? "state-error" : void 0}
    onChange={() => clearQuoteError("state")}
  >
                  <option value="" disabled>
                    Selecciona tu estado
                  </option>
                  {estados.map((estado) => <option key={estado}>{estado}</option>)}
                </select>
                {quoteErrors.state && <small className="field-error" id="state-error">
                    {quoteErrors.state}
                  </small>}
              </label>
              <Field
    label="Ciudad o población"
    id="city"
    name="city"
    required
    error={quoteErrors.city}
    onChange={() => clearQuoteError("city")}
  />
              <label
    className={`field-label${quoteErrors.businessType ? " is-error" : ""}`}
    htmlFor="businessType"
  >
                <span>Tipo de negocio</span>
                <select
    id="businessType"
    name="businessType"
    required
    defaultValue=""
    aria-invalid={quoteErrors.businessType ? "true" : void 0}
    aria-describedby={quoteErrors.businessType ? "businessType-error" : void 0}
    onChange={() => clearQuoteError("businessType")}
  >
                  <option value="" disabled>
                    Selecciona una opción
                  </option>
                  <option>Forrajera</option>
                  <option>Veterinaria</option>
                  <option>Tienda o abarrotes</option>
                  <option>Distribuidor mayorista</option>
                  <option>Otro</option>
                </select>
                {quoteErrors.businessType && <small className="field-error" id="businessType-error">
                    {quoteErrors.businessType}
                  </small>}
              </label>
              <label
    className={`field-label${quoteErrors.products ? " is-error" : ""}`}
    htmlFor="products"
  >
                <span>Productos y volumen aproximado</span>
                <textarea
    id="products"
    name="products"
    required
    aria-invalid={quoteErrors.products ? "true" : void 0}
    aria-describedby={quoteErrors.products ? "products-error" : void 0}
    onChange={() => clearQuoteError("products")}
  />
                {quoteErrors.products && <small className="field-error" id="products-error">
                    {quoteErrors.products}
                  </small>}
              </label>
              <Button
    type="submit"
    disabled={quoteLoading}
    aria-busy={quoteLoading}
  >
                {quoteLoading ? "Enviando..." : "Quiero mi cotizaci\xF3n"}
                {!quoteLoading && <ArrowRight aria-hidden="true" />}
              </Button>
              <small>Te respondemos por WhatsApp.</small>
              {quoteStatus && <p className="form-status is-success" role="status">
                  {quoteStatus}
                </p>}
            </form>
          </section>
        </div>
      </main>

      <footer className="rise">
        <div className="wrap">
          <div className="footer-main">
            <h2>Una gran croqueta para el mundo práctico y accesible.</h2>
            <div className="footer-logos">
              <img src={logoPetFoodPrimary} alt="División Pet Food" />
              <img className="footer-logo-19" src={logo19Hermanos} alt="Los 19 Hermanos" />
            </div>
          </div>
          <div className="footer-bottom">
            <div>
              <strong>{brand.direccion}</strong>
              <a href={brand.mapsUrl} target="_blank" rel="noopener noreferrer">
                Ver en Google Maps
              </a>
              <span>Síguenos: {brand.instagram.handle}</span>
              <div className="social-links">
                <a
    href={brand.instagram.url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram de 19H Pet Food"
  >
                  <InstagramLogo weight="regular" aria-hidden="true" />
                </a>
                <a
    href={brand.facebook.url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook de 19H Pet Food"
  >
                  <FacebookLogo weight="regular" aria-hidden="true" />
                </a>
              </div>
            </div>
            <div>
              <strong>Ventas y WhatsApp: 33 17 15 66 70</strong>
              <span>Planta: 391 916 00 67</span>
              <span>Gerencia de ventas: 392 132 3212</span>
              <a href="mailto:atencionalcliente.mascotas@19hnos.com">
                Atención al cliente: atencionalcliente.mascotas@19hnos.com
              </a>
              <a href="mailto:petfood_almacenes@19hnos.com">
                Mayoreo: petfood_almacenes@19hnos.com
              </a>
            </div>
            <div>
              <strong>Pet Food de 19 Hermanos.</strong>
              <span>Leche 19 Diecinueve Hermanos, S.A. de C.V.</span>
              <span>Aviso de privacidad</span>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}
const pageTitle = "Alimento para perro y gato | 19H Pet Food · Tototlán, Jalisco";
const pageDescription = "Silver Kan, Silver Cat, Kan Kan y Mi Boob, hechos en Tototlán, Jalisco. Compara fórmulas, calcula cuánto te dura el bulto y pide por WhatsApp.";

export default function PetFoodPreview() {
  useEffect(() => {
    document.documentElement.classList.add("pf-html");
    document.body.classList.add("pf-body");
    const previousTitle = document.title;
    document.title = pageTitle;
    const specs = [
      ["meta[name='title']", pageTitle],
      ["meta[name='description']", pageDescription],
      ["meta[property='og:title']", pageTitle],
      ["meta[property='og:description']", pageDescription],
      ["meta[property='og:locale']", "es_MX"]
    ];
    const restores = specs.map(([selector, value]) => {
      const el = document.head.querySelector(selector);
      if (!el) return null;
      const previous = el.getAttribute("content");
      el.setAttribute("content", value);
      return () => el.setAttribute("content", previous);
    });
    return () => {
      document.documentElement.classList.remove("pf-html");
      document.body.classList.remove("pf-body");
      document.title = previousTitle;
      restores.forEach((restore) => restore && restore());
    };
  }, []);

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:locale" content="es_MX" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <App />
    </>
  );
}
